import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Facebook Coupon Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform='facebook' experienceType='fb_coupon' />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-coupon/create/index.js